import { css, FlattenInterpolation, ThemeProps } from "styled-components";

export const styleWrappedComponent = <T extends ThemeProps<unknown>>(
  style: FlattenInterpolation<T>,
) => css<T>`
  > *:first-child {
    ${style};
  }
`;
